import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { MotionConfig } from "motion/react";
import { ApiError } from "@/lib/api";
import { keepCatalogFresh } from "@/lib/catalog";
import { CartProvider } from "@/lib/cart";
import { I18nProvider } from "@/lib/i18n";
import { ToastProvider } from "@/lib/toast";
import App from "./App";
import "./index.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Client errors (401/403/404…) are final; only retry network/server failures.
      retry: (count, err) => !(err instanceof ApiError && err.status < 500) && count < 2,
      refetchOnWindowFocus: true,
    },
  },
});
// Admin changes (products, prices, availability, categories) appear without a manual refresh.
keepCatalogFresh(queryClient);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <I18nProvider>
        {/* Respect the OS "reduce motion" setting for every animation */}
        <MotionConfig reducedMotion="user">
          <ToastProvider>
            <CartProvider>
              <App />
            </CartProvider>
          </ToastProvider>
        </MotionConfig>
      </I18nProvider>
    </QueryClientProvider>
  </StrictMode>,
);
